import { getFeature } from '../../server/features/helpers';
export function isInsideEditor(element) {
    if (typeof document === 'undefined') {
        return;
    }
    return element.closest('.editor-wrapper');
}
export function isEditorTextEmpty(editorText) {
    let isEmpty;
    const isEmptyFeature = getFeature('IS_EMPTY_FEATURE', editorText.html.features);
    if (isEmptyFeature) {
        isEmpty = isEmptyFeature && isEmptyFeature.data.isEmpty;
    } else {
        const wordCountFeature = getFeature('WORD_COUNT_FEATURE', editorText.html.features);
        isEmpty = wordCountFeature && wordCountFeature.data.chars === 0;
    }
    return isEmpty;
}
export function fromPlainText(text) {
    const doc = {
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: text !== null && text !== void 0 ? text : ' '
                    }
                ]
            }
        ]
    };
    return {
        excerpt: "Happy panda boi! I absolutely adore pandas and don't think they deserve the bad rep they get. Juststice for Pandas!👏 He also got little froggo friends to play with🐸 Have a lovely day everyooonnneeeee!!",
        html: {
            type: 'tiptap',
            markup: JSON.stringify(doc),
            features: '[]'
        }
    };
}

//# sourceMappingURL=helpers.js.map